module.exports = __webpack_public_path__ + "static/media/newsletter-august-2021-holy-cross.1cc34072.jpg";